import { Directive, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[as-link]'
})
export class AsLinkDirective {
  @Input() rounded: boolean = false;
  @Input() inset: boolean = false;
  @Output() click: EventEmitter<Event> = new EventEmitter<Event>();

  @HostBinding('attr.role') role: string = 'link';
  @HostBinding('attr.tabindex') tabindex: string = '0';
  @HostBinding('class.focus-visible') base_class: boolean = true;
  @HostBinding('class.focus-visible-rounded') get roundedClass(): boolean {
    return this.rounded;
  }
  @HostBinding('class.focus-visible-inset') get insetClass(): boolean {
    return this.inset;
  }

  @HostListener('keydown.Enter', ['$event'])
  @HostListener('keydown.Space', ['$event'])
  keydownHandler(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    this.click.emit(event);
  }
}
